import styled from 'react-emotion';

const ContentWrapper = styled.div`
  background: #f2f2f2;
  height: 100%;
`;

export const FullPage = styled.div`
  position: absolute; /* inherit parent height which is specified by min-height */
  width: 100%;
  height: calc(100% - 88px);
`;

export const VerticalCenter = styled(FullPage)`
  display: flex;
  align-items: center;
`;

export const WhiteContentWrapper = styled(ContentWrapper)`
  background: white;
`;

export default ContentWrapper;



// WEBPACK FOOTER //
// ./src/components/content-wrapper.jsx